import React, { Fragment } from 'react';

// Conditional CSS import via React.lazy and React.Suspense
// https://prawira.medium.com/react-conditional-import-conditional-css-import-110cc58e0da6
const Development  = React.lazy(() => import('./Development'));
const Production = React.lazy(() => import('./Production'));

const EnvironmentSelector = ({ children }) => {
  const production = process.env.REACT_APP_ENV === 'production';

  return (
    <Fragment>
      <React.Suspense fallback={<Fragment></Fragment>}>
        {production && <Production />}
        {!production && <Development />}
      </React.Suspense>
      {children}
    </Fragment>
  )
}

export default EnvironmentSelector;


// WEBPACK FOOTER //
// ./src/environments/Selector.js